export type TextToken =
  | { kind: "text"; text: string }
  | { kind: "variable"; name: string };

const VAR_REGEX = /\{\{([^}]+)\}\}/g;

/**
 * Parses a raw text string and splits it into text and variable tokens.
 *
 * Example:
 *   "Cena je {{price}} za kus." → [
 *     { kind: "text", text: "Cena je " },
 *     { kind: "variable", name: "price" },
 *     { kind: "text", text: " za kus." },
 *   ]
 */
export function parseSegmentText(rawText: string): TextToken[] {
  const result: TextToken[] = [];
  let lastIndex = 0;

  const regex = new RegExp(VAR_REGEX.source, "g");
  let match: RegExpExecArray | null;

  // biome-ignore lint/suspicious/noAssignInExpressions: standard regex loop
  while ((match = regex.exec(rawText)) !== null) {
    if (match.index > lastIndex) {
      result.push({
        kind: "text",
        text: rawText.slice(lastIndex, match.index),
      });
    }
    result.push({ kind: "variable", name: match[1].trim() });
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < rawText.length) {
    result.push({ kind: "text", text: rawText.slice(lastIndex) });
  }

  return result;
}

/**
 * Extracts all variable names referenced in a text string.
 */
export function extractVariableNames(text: string): string[] {
  const matches = [...text.matchAll(VAR_REGEX)];
  return matches.map((m) => m[1].trim()).filter(Boolean);
}
